/*
 * fn: getCookies
 *
 * Gets cookies from universal-cookie package, defined once
 *
 * If run on the server, returns a new instance each time as to not persist between sessions
 *
 */
import Cookies from 'universal-cookie'

let COOKIES: Cookies | null = null

export const getCookies = () => {
  if (typeof document === 'undefined') return new Cookies()

  COOKIES ??= new Cookies()

  return COOKIES
}
